// "YYYY-MM-DD" --> "DD.MM.YYYY"
export function serverDateToClientDate(serverDate) {
    const regex = /^(\d\d\d\d)-(\d\d)-(\d\d)$/;
    const match = regex.exec(serverDate);
    if (!match)
        throw new Error(`invalid serverDate format: ${serverDate}`);
    return `${match[3]}.${match[2]}.${match[1]}`;
}

// "D.M.Y" --> "YYYY-MM-DD"
export function clientDateToServerDate(clientDate) {
    const regex = /^\s*(\d{1,2})\s*\.\s*(\d{1,2})\s*\.\s*(\d{1,4})\s*$/;
    const match = regex.exec(clientDate);
    if (!match)
        throw new Error(`invalid clientDate format: ${clientDate}`);
    return `${match[3].padStart(4, "0")}-${match[2].padStart(2, "0")}-${match[1].padStart(2, "0")}`;
}